import { AuthError } from '@/api/client'

type AuthenticationRecoveryOptions = {
  mode: 'msal' | 'token'
  onTokenUnauthorized: () => void
  onMsalUnauthorized: () => Promise<void>
  onRecoveryError?: (error: unknown) => void
}

export function createAuthenticationRecovery({
  mode,
  onTokenUnauthorized,
  onMsalUnauthorized,
  onRecoveryError,
}: AuthenticationRecoveryOptions) {
  let isRecovering = false

  return (error: unknown) => {
    if (!(error instanceof AuthError) || error.status !== 401 || isRecovering) return
    isRecovering = true

    if (mode === 'token') {
      try {
        onTokenUnauthorized()
      } catch (recoveryError) {
        isRecovering = false
        onRecoveryError?.(recoveryError)
      }
      return
    }

    void onMsalUnauthorized()
      .catch((recoveryError: unknown) => {
        onRecoveryError?.(recoveryError)
      })
      .finally(() => {
        isRecovering = false
      })
  }
}
